import { AbstractControl } from '@angular/forms';
import { DateTime } from 'luxon';

export interface BirthDateOptions {
  minAge: number;
  maxAge: number;
}

export function BirthDateValidator(options: BirthDateOptions) {
  return function (AC: AbstractControl) {
    if (!AC.value) return null;
    const errors: { minAge?: boolean; maxAge?: boolean; format?: boolean } = {};
    const datePattern = /^\d{2}\/\d{2}\/\d{4}$/;

    if (datePattern.test(AC.value)) {
      const d = DateTime.fromFormat(AC.value, 'mm/dd/yyyy');
      const today = DateTime.local();
      const age = today.diff(d).as('years');
      if (options.maxAge && age > options.maxAge) {
        errors.maxAge = true;
      }
      if (options.minAge && age < options.minAge) {
        errors.minAge = true;
      }
    } else {
      errors.format = true;
    }
    if (Object.keys(errors).length > 0) {
      return errors;
    } else {
      return null;
    }
  };
}
